import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchChannels } from "../../../views/Dashboard/Messages/chatApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Chat at a glance: unread counts split by direct messages vs the group
// channels (company-wide + your branch), plus who wrote last.
const MessagesWidget = () => {
  const user = useSelector(selectUser);
  const [channels, setChannels] = useState(null);

  useEffect(() => {
    if (!user?.email) return;
    fetchChannels(user.email)
      .then((data) => setChannels(Array.isArray(data) ? data : []))
      .catch(() => setChannels([]));
  }, [user?.email]);

  if (!channels) {
    return (
      <WidgetFrame title="Messages" to="/messages">
        <WidgetEmpty>Loading your conversations…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const dms = channels.filter((c) => c.type === "dm");
  const groups = channels.filter((c) => c.type !== "dm");
  const dmUnread = dms.reduce((sum, c) => sum + (c.unread || 0), 0);
  const groupUnread = groups.reduce((sum, c) => sum + (c.unread || 0), 0);

  const latest = channels
    .filter((c) => c.lastMessage)
    .sort(
      (a, b) =>
        new Date(b.lastMessage.createdAt) - new Date(a.lastMessage.createdAt)
    )[0];

  return (
    <WidgetFrame title="Messages" to="/messages">
      <div className="grid grid-cols-3 gap-2">
        <WidgetStat value={dmUnread + groupUnread} label="Unread" />
        <WidgetStat value={dmUnread} label="Direct" />
        <WidgetStat value={groupUnread} label="Channels" />
      </div>
      {latest && (
        <p className="app-muted mt-2 truncate text-xs">
          {latest.name}: {(latest.lastMessage.authorName || "").split(" ")[0]}
          {" — "}
          {latest.lastMessage.text ||
            (latest.lastMessage.hasAttachment ? "📷 Photo" : "")}
        </p>
      )}
    </WidgetFrame>
  );
};

export default MessagesWidget;
